/**
 * Tab types and constants for the main application navigation
 */

export type TabId =
  | 'picks'
  | 'parlays'
  | 'lab'
  | 'leaderboard'
  | 'search'
  | 'feed'
  | 'summary'
  | 'breakdown'
  | 'issues'
  | 'strategy'
  | 'market'
  | 'admin';

export interface Tab {
  id: TabId;
  label: string;
  shortLabel?: string;
}

export const PRIMARY_TABS: Tab[] = [
  { id: 'picks', label: "Today's Picks", shortLabel: 'Picks' },
  { id: 'parlays', label: 'My Bets', shortLabel: 'Bets' },
  { id: 'leaderboard', label: 'Leaderboard', shortLabel: 'Board' },
  { id: 'search', label: 'Search' },
  { id: 'feed', label: 'Activity' },
];

export const ANALYTICS_TABS: Tab[] = [
  { id: 'summary', label: 'Summary' },
  { id: 'breakdown', label: 'Breakdown' },
  { id: 'issues', label: 'Issues' },
  { id: 'strategy', label: 'Strategy' },
  { id: 'market', label: 'Market' },
];
